import React, { forwardRef, ReactNode } from 'react';
import classNames from 'classnames';

export interface FormGroupProps {
  children: ReactNode;
  error?: boolean | string;
  className?: string;
  id?: string;
}

const FormGroup = forwardRef<HTMLDivElement, FormGroupProps>(
  ({ children, className, error, id }: FormGroupProps, ref): JSX.Element => {
    return (
      <div
        id={id}
        className={classNames('usa-form-group', className, {
          'usa-form-group--error': error,
        })}
        ref={ref}
      >
        {children}
      </div>
    );
  },
);

export default FormGroup;
